import React from 'react'
import MaterialSymbol from '../material-symbol'

const ConfirmationNumber = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="confirmation_number" {...props} />
))

ConfirmationNumber.displayName = 'ConfirmationNumber'

export default ConfirmationNumber
